































import Vue from 'vue'
import { Prop, Component, Watch } from 'vue-property-decorator';
import DevExpress from 'devextreme';
import { DataGrid } from '@questelservices/common-vue';
import { BatchDetailsDto } from '../../models/batch/BatchDetailsDto';
import { BatchTypes } from '../../models/batch/BatchTypeEnum';
import { DxColumn, DxLookup } from 'devextreme-vue/data-grid';
import { SelectOption } from '@/models/SelectOption';

@Component({
  components: {
    DataGrid,
    DxColumn,
    DxLookup
  }
})
export default class BatchList extends Vue {
  $refs: Vue['$refs'] & {
    batchListDataGrid?: DataGrid;
  } = {};

  @Prop({ required: true })
  batches!: Array<BatchDetailsDto>;

  @Prop({ default: true })
  showClient!: boolean;

  batchTypes: Array<SelectOption> = BatchTypes;

  private get dxDataGrid(): DevExpress.ui.dxDataGrid {
    return (this.$refs.batchListDataGrid as any).$refs.dxDataGrid.instance;
  }

  @Watch('batches')
  private batchesChanged(val: any, oldVal: any) {
    this.dxDataGrid.refresh();
  }

  private get dataStoreOptions() : DevExpress.data.CustomStoreOptions {
    return {
      key: 'BatchId',
      loadMode: 'raw',
      load: () => { return this.batches }
    }
  }
}
